import InterimStoreAvailablityGrid from './interim-store-availablity-grid/interim-store-availablity-grid';
import InterimStoreAvailablityTable from './interim-store-availablity-table/interim-store-availablity-table';
import { InterimStoreAvailabilityType } from './types';

const StoreAvailabilityWrapper = ({
  hideLabel,
  hoseAssemblyDetails,
  isLoading,
  isDeliveryEnabled,
  isPickupEnabled,
  availabilityToolTipMessage,
  sourcingDetails,
  shouldWrap,
  address,
  locale,
  hideToolTipIcon,
  availabilityByStoreLink,
  showPickupCutoffFlag,
  storeAvailability,
  isPDPPage = false,
  pdpEstimatedDeliveryDateFlag,
  isLoggedIn,
  cutoffTimesData,
  deliveryAvailability
}: InterimStoreAvailabilityType) => {
  return (
    <div data-testid="store-availability-wrapper">
      {isPDPPage ? (
        <InterimStoreAvailablityGrid
          isLoading={isLoading}
          isDeliveryEnabled={isDeliveryEnabled}
          isPickupEnabled={isPickupEnabled}
          address={address}
          locale={locale}
          storeAvailability={storeAvailability}
          showPickupCutoffFlag={showPickupCutoffFlag}
          pdpEstimatedDeliveryDateFlag={pdpEstimatedDeliveryDateFlag}
          isLoggedIn={isLoggedIn}
          cutoffTimesData={cutoffTimesData}
          deliveryAvailability={deliveryAvailability}
        />
      ) : (
        <InterimStoreAvailablityTable
          hideLabel={hideLabel}
          hoseAssemblyDetails={hoseAssemblyDetails}
          isLoading={isLoading}
          isDeliveryEnabled={isDeliveryEnabled}
          isPickupEnabled={isPickupEnabled}
          availabilityToolTipMessage={availabilityToolTipMessage}
          hideHeaderAndDeliveryOptions={false}
          sourcingDetails={sourcingDetails}
          shouldWrap={shouldWrap}
          address={address}
          locale={locale}
          hideToolTipIcon={hideToolTipIcon}
          availabilityByStoreLink={availabilityByStoreLink}
        />
      )}
    </div>
  );
};

export default StoreAvailabilityWrapper;
